import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";
export default function* watcherDeleteSupplierSaga() {
  yield takeEvery("DELETE_SUPPLIER", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    var url = `/delete-supplier/${action.payload}`;
    yield request("delete", action.payload, url).then((response) => {
      payload = response;
    });

    if (payload.success) toast.success("Supplier Deleted Successfully");

    var formatUrl = "/get-suppliers";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "SUPPLIERS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
